import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { c as o } from "../../index-BkL7vJ-E.js";
import { s as r } from "../../IPCheck.module-D80DEiWS.js";
const s = ({ checkIp: a, videoCover: c }) => /* @__PURE__ */ t("div", { className: o(r.cover, "hamrah-player__check-ip-cover"), onClick: a, children: [
  c && /* @__PURE__ */ e("img", { src: c ?? "", className: o(r.coverImage, "hamrah-player__check-ip-cover__cover"), alt: "cover" }),
  /* @__PURE__ */ e("button", { type: "button", className: o(r.button, "hamrah-player__check-ip-cover__button"), children: /* @__PURE__ */ e("svg", { width: "96", height: "97", viewBox: "0 0 96 97", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ e("g", { id: "Bold / Video, Audio, Sound / Play", children: /* @__PURE__ */ e(
    "path",
    {
      id: "Polygon 1",
      d: "M85.6343 37.9103C94.1219 42.5259 94.1219 54.4741 85.6343 59.0897L34.3865 86.9581C26.1374 91.4439 16 85.6053 16 76.3684L16 20.6316C16 11.3947 26.1374 5.55609 34.3865 10.0419L85.6343 37.9103Z",
      fill: "#F5F5F5"
    }
  ) }) }) })
] });
export {
  s as default
};
